import { IFilter } from '@/models/filters.model';

export const normalizeFilterFormValues = (filterValues: IFilter) => ({
  ...filterValues,
  categories: filterValues.categories?.map((category) => category.id) || [],
});
